import { BenchmarkingLineOfBusinessEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared";
import { ClaimsActivityLineOfBusinessTypeEnum } from "@app/projects/network-assessment/pci-dashboard/claims-activity";

function getPcaLineOfBusiness(selectedLineOfBusiness: BenchmarkingLineOfBusinessEnum): ClaimsActivityLineOfBusinessTypeEnum {
  switch (selectedLineOfBusiness) {
    case BenchmarkingLineOfBusinessEnum.Medicare:
      return ClaimsActivityLineOfBusinessTypeEnum.Medicare;
    case BenchmarkingLineOfBusinessEnum.Marketplace:
      return ClaimsActivityLineOfBusinessTypeEnum.Commercial;
    default:
      return ClaimsActivityLineOfBusinessTypeEnum.Medicare;
  }
}

export { getPcaLineOfBusiness };